module.exports = __webpack_public_path__ + "img/mw.479bfd88.svg";